import React from 'react'
import Alert from '@mui/material/Alert'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import S3DocumentUploadDisplay from '../../components/images/S3DocumentUploadDisplay'
import API from '../../services/API'
import { FormSection, YesNoQuestion } from './FormKit'

const DBS = ({ formValues, setFormValues }) => {
  const dbs = formValues?.dbs ?? {}
  const hasCertificate = dbs.has3month === true || dbs.onUpdateService === true

  const setDbs = (patch) =>
    setFormValues((prev) => ({ ...prev, dbs: { ...prev.dbs, ...patch } }))

  const saveDocuments = (documents) => {
    setDbs({ documents })
    API.post('/update-employee-own-application', {
      _id: formValues._id,
      dbs: { ...formValues.dbs, documents },
    })
  }

  return (
    <Stack gap={2}>
      <FormSection title="Your DBS certificate">
        <Stack gap={2.5}>
          <YesNoQuestion
            label="Do you have an enhanced DBS certificate less than 3 months old?"
            value={dbs.has3month}
            onChange={(has3month) => setDbs({ has3month })}
          />
          <YesNoQuestion
            label="Are you registered with the DBS Update Service?"
            value={dbs.onUpdateService}
            onChange={(onUpdateService) => setDbs({ onUpdateService })}
          />
          {hasCertificate && (
            <TextField
              label="Certificate number"
              helperText="The 12-digit number at the top of your certificate"
              autoComplete="off"
              name="DBScertNumber"
              value={dbs.certificateNumber ?? ''}
              onChange={(e) => setDbs({ certificateNumber: e.target.value })}
              sx={{ maxWidth: { sm: 360 } }}
            />
          )}
          {dbs.onUpdateService && dbs.certificateNumber && (
            <YesNoQuestion
              label="Do you consent to us checking the status of your certificate online?"
              value={dbs.consentsToStatusCheck}
              onChange={(consentsToStatusCheck) =>
                setDbs({ consentsToStatusCheck })
              }
            />
          )}
          {!hasCertificate &&
            (dbs.has3month === false || dbs.onUpdateService === false) && (
              <Alert severity="info">
                You'll need to complete an enhanced DBS check with us if your
                application is accepted.
              </Alert>
            )}
        </Stack>
      </FormSection>

      {hasCertificate && (
        <FormSection
          title="Documents"
          caption="Upload a copy of your most recent DBS certificate."
        >
          <S3DocumentUploadDisplay
            existingDocuments={dbs.documents}
            s3folder="employees/application-dbs-documents"
            actionAfterSubmit={(newDocKey) =>
              saveDocuments([...(dbs.documents ?? []), newDocKey])
            }
            actionAfterDelete={(newDocsArray) => saveDocuments(newDocsArray)}
          />
        </FormSection>
      )}
    </Stack>
  )
}

export default DBS
